import { NgModule } from '@angular/core';
import { DatetimeFormatPipe } from './datetime-format.pipe';
import { DefaultDateFormatPipe } from './default-date-format.pipe';

@NgModule({
  declarations: [DefaultDateFormatPipe, DatetimeFormatPipe],
  exports: [DefaultDateFormatPipe, DatetimeFormatPipe],
})
export class CustomPipesModule {}
